import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout flex flex-row align-middle justify-center" }, null, -1)
const _hoisted_3 = { class: "relative flex justify-center overflow-hidden h-screen" }
const _hoisted_4 = { class: "overflow-x-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Header = _resolveComponent("Header")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      class: "items-center",
      isBorderBottom: false
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_lp_button, {
          onClick: _ctx.goToCreate,
          title: "Buat Konfigurasi Cashback",
          textColor: "white"
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_TableV2, {
          columns: _ctx.columns,
          data: _ctx.cashbackList.data,
          loading: _ctx.isLoading,
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
          paginationStyle: "v3",
          onRequest: _ctx.fetchCashbackList,
          errorCause: _ctx.errorCause,
          isDetailAble: _ctx.ableToDetail,
          onClick: _ctx.goToDetail,
          isEmpty: !_ctx.isLoading && !_ctx.cashbackList.data.length && !_ctx.isError,
          emptyMessage: "Belum ada data konfigurasi"
        }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "errorCause", "isDetailAble", "onClick", "isEmpty"])
      ])
    ])
  ]))
}